import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment/index.js';
import { DatePickerProps as MuiDatePickerProps } from '@mui/x-date-pickers/DatePicker/index.js';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/index.js';
import Box from 'component/layoutComponents/Box';
import moment from 'moment';
import React, { useEffect } from 'react';
import { StyledDateTimePicker, StyledFormLabel } from './DatePicker.style';

export interface DatePickerProps extends MuiDatePickerProps<any> {
  label?: string;
  boldLabel?: boolean;
  error?: boolean;
  required?: boolean;
  onChange: (date: any) => void;
  useInitValue?: boolean;
}

const DatePicker = (props: DatePickerProps) => {
  const {
    label,
    boldLabel,
    error,
    required,
    onChange,
    defaultValue,
    useInitValue = true,
    ...muiDatePickerProps
  } = props;

  useEffect(() => {
    if (!useInitValue) return;
    if (defaultValue) {
      onChange(defaultValue);
    }
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
      <Box>
        {label && (
          <Box display="flex">
            <StyledFormLabel boldLabel={boldLabel} required={required}>
              {label}
            </StyledFormLabel>
          </Box>
        )}

        <StyledDateTimePicker format="YYYY-MM-DD" error={error} {...muiDatePickerProps} onChange={onChange} />
      </Box>
    </LocalizationProvider>
  );
};

export default DatePicker;
